export enum Roles {
  Admin = 'Admin',
  StudyManager = 'Study Manager',
  Patient = 'Patient',
  Carer = 'Carer',
  AdminContract = 'Admin Contract',
  AdminOrg = 'Admin Org',
  AdminService = 'Admin Service',
  AdminDepartment = 'Admin Department'
}
